<template>
    <div class="keep-watching-card">
        <img class="keep-watching-card__img" :src="image" alt="" />
        <div class="keep-watching-card__content">
            <h3 class="keep-watching-card__title">{{ truncatedTitle }}</h3>
            <p class="keep-watching-card__description">{{ description }}</p>
            <a class="keep-watching-card__btn" :href="`/aluno/curso/${id}`">
                <i class="pi pi-play"></i>
                <span> Continuar de onde parei </span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'KeepWatchingCard',
        props: {
            id: {
                type: String,
                required: true,
            },
            image: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: 'Continue Assistindo',
            },
            description: {
                type: String,
                default: '',
            },
        },
        computed: {
            truncatedTitle() {
                if (this.title.length > 80) {
                    return this.title.slice(0, 80) + '...';
                }
                return this.title;
            },
        },
        data() {
            return {
                // Define any data properties if needed
            };
        },
    };
</script>

<style scoped>
    .keep-watching-card {
        width: 100%;
        background-color: #ffffff;
        overflow: hidden;
        border-radius: 8px;
        box-shadow: 0 1px 26px 5px rgba(184, 192, 206, 0.25);
    }

    .dark .keep-watching-card {
        background-color: #181a20 !important;
        box-shadow: 0 1px 26px 5px rgba(0, 0, 0, 0.25);
    }

    .keep-watching-card__img {
        width: 100%;
        height: 240px;
        object-fit: cover;
    }

    .keep-watching-card__content {
        padding: 20px;
        text-align: start;
        max-height: 100%;
    }

    .keep-watching-card__title {
        font-size: 24px;
        font-weight: 700;
        color: #242424;
        margin-bottom: 16px;
    }

    .dark .keep-watching-card__title {
        color: #ffffff;
    }
    .dark .keep-watching-card__description {
        color: #b4b1ad !important;
    }
    .keep-watching-card__description {
        font-size: 16px;
        color: #242424;
        margin-bottom: 16px;
    }

    .keep-watching-card__btn {
        display: inline-flex;
        padding: 12px 16px 12px 12px;
        background-color: #123282;
        color: #ffffff;
        text-decoration: none;
        border-radius: 4px;
        font-weight: 600;
        font-size: 14px;
        transition: 300ms ease-in-out;
        cursor: pointer;

        align-items: center;
        gap: 8px;
    }

    .keep-watching-card__btn:hover {
        background-color: #0f2a5c;
    }

    @media screen and (min-width: 768px) {
        .keep-watching-card {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .keep-watching-card__img {
            order: 2;
            height: 306px;
            width: 46%;
        }

        .keep-watching-card__content {
            order: 1;
            width: 54%;
            padding: 48px;
        }

        .keep-watching-card__title {
            font-size: 32px;
            margin-bottom: 24px;
        }
    }
</style>
